<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="スケジュールのタイムゾーン変更"
        ok-title="変更する"
        ok-variant="yokumiru-orange"
        cancel-title="キャンセル"
        cancel-variant="yokumiru-gray"
        @ok="confirm"
        @hidden="close">
        <template v-if="timezoneObj !== null">
            <div v-if="isDeviceScheduleTimezone == 1">
                <p class="mt-3 mb-0">スケジュールのタイムゾーンは、<span class="timezoneObj">デバイスのタイムゾーン&nbsp;&nbsp;{{ timezoneObj.value }}</span>&nbsp;&nbsp;に変更されます。</p>
                <p>現在登録中の全てのスケジュールはリセットされます。変更してよろしいですか？</p>
                <p>※&nbsp;キャンセルした場合、「デバイスのタイムゾーンに合わせる」設定が&nbsp;OFF&nbsp;になります。</p>
            </div>
            <div v-else>
                <p class="mt-3 mb-0">スケジュールのタイムゾーンは、&nbsp;&nbsp;<span class="timezoneObj">{{ timezoneObj.value }}</span>&nbsp;&nbsp;に変更されます。</p>
                <p>現在登録中の全てのスケジュールはリセットされます。変更してよろしいですか？</p>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                confirmed: false,
                timezoneObj: null,
                isDeviceScheduleTimezone: false,
            };
        },

        created: function() {
            bus.$on('open-modal-doctor-timezone-confirm', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-timezone-confirm')
        },

        methods: {
            open: function (timezoneObj, isDeviceScheduleTimezone) {
                this.modalShow = true
                this.confirmed = false
                this.timezoneObj = timezoneObj
                this.isDeviceScheduleTimezone = isDeviceScheduleTimezone
            },

            close: function () {
                this.modalShow = false

                if (!this.confirmed) {
                    bus.$emit('schedule-timezone-canceled')
                }
            },

            confirm: async function (e) {
                e.preventDefault()
                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    schedule_timezone: this.timezoneObj.key,
                    is_device_schedule_timezone: this.isDeviceScheduleTimezone,
                }

                // 既存のスケジュールを全て削除
                await axios.post(constants.doctor.schedules.endpoint.deleteAll, params)
                    .then(async () => {
                        // スケジュールのタイムゾーンを更新
                        await axios.put(`${constants.doctor.me.endpoint.base}/schedule_timezone`, params)
                            .then(() => {
                                bus.$emit('alert-success', 'スケジュールをリセットしました。')
                                bus.$emit('schedule-timezone-confirmed')
                                this.confirmed = true
                                this.close()
                            })
                            .catch(() => {
                                bus.$emit('alert-danger', 'システムエラーが発生しました。')
                            })
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style scoped lang="scss">
.timezoneObj {
    color: #333;
    font-weight: bold;
}
</style>
